import { Dispatch } from "../../config/controller";
import { Procedimento } from "../../config/data.types";
import { Model,StateProps } from "../../config/model";

export type { Procedimento } from "../../config/data.types";

export interface ProcedimentoState extends StateProps<Procedimento> {
    
}

export interface ProcedimentoActions extends Dispatch<Procedimento> {
    selecionarProcedimento:(set:boolean)=>any
}

const model = new Model<Procedimento,ProcedimentoState>("procedimento");

export const initialValueProcedimento:Procedimento = {
    ...model.getInitialValue(),
    type:"procedimento",
    descricao:""
}

export const initialValueProcedimentoState:ProcedimentoState = {
    ...model.getInititalValueState(),
    row:initialValueProcedimento,   
}


